export default "__VITE_ASSET__DuWmD5Ks__"